<label *ngIf="!isInnerLabel" (click)="onFocus()" class="main-label">
    {{ label }}
</label>
<div>
    <label *ngIf="label2&&!isInnerLabel" (click)="onFocus()" class="sub-label">
        {{ label2 }}
    </label>
</div>


<div #wrap class="input-wrap relative">
    <input #input *ngIf="mode === 'input'" title="field" [(ngModel)]="value" [formControl]="formControl"
           [attr.aria-label]="label"
           [attr.type]="type" [readonly]="readonly" [maxValue]="maxValue" [minValue]="minValue"
           [igOnlyIntegerInput]="type === 'number'" [igOnlyFloatInput]="type === 'float'" [required]="isRequired"
           [placeholder]="isInnerLabel?label:placeholder" [autocomplete]="autocomplete || (type === 'password' ? 'off' : 'on')"
           (focus)="focus()" (keyup)="onKeyup($event)" (blur)="onBlur()"/>

    <textarea *ngIf="mode==='textarea'" matInput
              [maxlength]="maxlength" [formControl]="formControl"
              (focus)="focus()" (keyup)="onKeyup($event)" (blur)="onBlur()"></textarea>

    <mat-icon *ngIf="!!icon&&!(isSearch&&value)" [class.innerIcon]="isInnerLabel"
              (click)="iconClick()">{{ icon }}
    </mat-icon>
    <mat-icon *ngIf="isSearch&&value&&!searching" [class.innerIcon]="isInnerLabel" (click)="clear()"
              class="pointer">clear
    </mat-icon>
</div>

<ig-spinner *ngIf="isSearch&&searching" [strokeWidth]="2" [diameter]="24"></ig-spinner>

<div class="error-text" *ngIf="!!errorText">
    {{ errorText }}
</div>

<div class="mask" *ngIf="disabled"></div>



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/field/field.component.html